<template>
  <div class="workList">
    <div class="header">
      <div class="container">
        <img class="logo" src="/img/ghltjLogo.png" alt="">
        <template v-if="gIsLogin()">
          <router-link class="nav" to="/personal_info">完善信息</router-link>
          <span class="nav" @click="logOut">退出登录</span>
        </template>
        <template v-else>
          <router-link class="nav" :to="{path:'/login?fromUrl=/ddf_vote_newer?p_type=' + prizeId}">登录</router-link>
          <router-link class="nav" :to="{path:'/register?fromUrl=/ddf_vote_newer?p_type=' + prizeId}">注册</router-link>
        </template>  
      </div>
    </div>
    <div class="banner">
      <img class="bannerImg" src="/img/ddfVote/banner.jpg" alt="">
    </div>
    <div class="container">
      <p class="voteTitle" v-if="false"><span>第十六届（2020）光华龙腾奖</span><span class="voteTitle2"> · {{getPrizeText}}</span><span class="voteTitle2">公众投票</span></p>
      <p class="note-info">
        此次公众投票权重为10%，请大家慎重投票。<br>
        投票时间：12月09日 09:00 - 12月12日 09:00。<br>
        希望大家多多参与，您的参与对此次网络评选至关重要！<br>
        <span class="bold">注：每个用户享有10票的投票权利，即每人每部手机最多且需填满10票。</span>
      </p>
      <p class="type">总人数（{{list.length}}）</p>
      <!-- <Table class="voteTable" stripe :columns="columns" :data="list" :loading="loading" @on-select="select" @on-select-cancel="cancel"></Table> -->
      <div v-if="loading" class="note">
        <Icon class="turn" size="50" type="ios-loading" />
        <p>加载中...</p>
      </div>
      <template v-else>
        <template v-if="total>0">
          <Row :gutter="24">
            <Col v-for="l in list" :key="l.id" :lg="6" :md="12" :sm="12" :xs="12">
              <div class="workWrap">
                <span v-if="showCount" class="voteCount" >{{l.voteCount || 0}}票</span>
                <span v-if="!endVote&&startVote&&!userVote" class="selectBtn" @click="select(l.id)">{{selectList.indexOf(l.id)!=-1?'已选择':'选择'}}</span>
                <img v-if="l.avatar" class="img" :src="l.avatar" @load="gCenterImg($event, 1)" alt="">
                <div class="info myBar">
                  <div class="textInfo">
                    <p class="ellipsis workName">
                      <span>{{l.name}}</span>
                    </p>
                    <p>{{l.company}}</p>
                    <p>{{l.participantExt.position}}</p>
                    <p class="profile" v-html="l.participantExt.profile"></p>  
                  </div>
                  <div class="opacityDiv"></div>
                </div>
              </div>
            </Col>
          </Row>
        </template>
        <div v-else class="center">
          暂无提名选手
          <!-- <img class="emptyImg" src="../assets/empty.png" alt="">
          <p>暂无提名选手</p> -->
        </div>
      </template>
      <div class="btnWrap">
        <Button v-if="!endVote&&startVote" :loading="submitting" class="defaultBtn" @click="vote">{{userVote?'已投票':'投票'}}</Button>
        <Button v-if="endVote" disabled>投票已截止</Button>
        <Button v-if="!startVote" disabled>投票未开始</Button>
      </div>
      <div class="jishu">
        龙腾之星提供技术支持
      </div>
    </div>
    <div class="footer">
      <div class="container">
        <Row :gutter="30">
          <Col :lg="9" :md="9" :sm="24" :xs="24">
            <p>联系我们</p>
            <p>光华龙腾奖办公室</p>
            <p>地址：北京市大兴区金苑路26号院3号楼三层</p>
            <p>电话：15810007797</p>
            <p>传真：010-83681552</p>
            <p>邮箱：601@ddfddf.org</p>
            <p>
              <img class="code" src="/img/ghltjCode.jpg" alt="">
            </p>
          </Col>
          <Col :lg="15" :md="15" :sm="24" :xs="24">
            <p>组织机构</p>
            <p>主办：北京光华设计发展基金会</p>
            <p>战略合作媒体：新华社主管《中国名牌》杂志</p>
            <p>合作单位：中国创新设计产业战略联盟、工业和信息化部工业文化发展中心、中国机械工程学会、中国建筑装饰协会、中国勘察设计协会、中国室内装饰协会、中国工业设计协会、中国流行色协会、中国服装设计师协会、全国工商联家具装饰业商会、北京设计学会、广东省工业设计协会、浙江省工业设计协会、上海工业设计协会、深圳市工业设计协会、深圳市工业设计产业协会、清华大学美术学院、中央美术学院、浙江大学、中国美术学院、湖南大学等</p>
            <p>专业媒体：《设计》杂志、中国工业设计报、《视觉中国》、《视觉同盟》、《创意世界》、时机科技等</p>
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
import Service from "@/api/ddfVote";
export default {
  data() {
    return {
      selectList: [],
      userVote: false,
      submitting: false,

      loading: false,
      total: 0,
      list: [],
      endVote: false,
      startVote: false,
      showCount: true,

      prizeId: null,
      prizeList: []
    };
  },
  mounted() {
    this.isStart();
    this.isEnd();
    // console.log(this.endVote);
    document.title =
      "公众投票 - 第十六届（2020）光华龙腾奖 · 中国设计业十大杰出青年提名奖获奖者公众投票正式开始！";
    this.prizeId = this.$route.query.p_type || 6;
    // this.getPrizeList();
    if (this.gIsLogin()) {
      this.getUserDdfVote();
    }
    this.total = 30;
    this.list = [
      {
        "id" : 174,
        "name" : "曹毕飞",
        "avatar" : "/img/ddf-vote-photo/caobifei.jpg",
        "company" : "广东工业大学艺术与设计学院",
        "participantExt" : {
          "position" : "首饰设计负责人、青年珠江学者",
          "profile" : `扎根中国传统文化研究，从传统工艺、传统生活方式、地方化知识、地域经济和文化资源中汲取创新养分进行设计实践；深入调研传统技艺如木制榫卯结构、金缕玉衣、竹编等，将技艺隐性知识、传统视觉文化和个人生活经历重铸，传承、创新并结合当代设计策略，在国际当代首饰设计领域开创多元文化与本土实践有机结合的新篇章。
<span style='text-indent:2em;display:block'>1.首本全英文《Chinese Contemporary Jewelry Design》专著美国出版，推动中国当代首饰设计全面走向世界；</span>
<span style='text-indent:2em;display:block'>2.首位中国籍，受邀2020国际艺术首饰论坛青年艺术家奖国际评审专家，成为1997年此奖举办以来第一个中国籍国际评委；</span>
<span style='text-indent:2em;display:block'>3.首位中国籍，受邀北美金工协会第47届年度会议主旨发言人，成为自1969年以来此会议历史上获此殊荣的第一个中国籍艺术家；</span>
<span style='text-indent:2em;display:block'>4.策划中国当代首饰面貌北美展，我国当代首饰设计领域首次聚集22位重要首饰设计者与艺术家集体亮相美国；</span>
<span style='text-indent:2em;display:block'>5.创建华南地区第一个当代首饰“跨夫特艺廊”，以艺术理念引领设计产业。</span>
个人曾荣获
<span style='text-indent:2em;display:block'>1. 2018国际艺术首饰论坛“艺术家奖”最高奖（首位中国籍获得者）</span>
<span style='text-indent:2em;display:block'>2. 2018广东省高等学校“青年珠江学者”（唯一）</span>
<span style='text-indent:2em;display:block'>3. 2013美国艺术类杰出人才</span>`,
        }
      },
      {
        "id" : 96,
        "name" : "陈慧聪",
        "avatar" : "/img/ddf-vote-photo/chenhuicong.jpg",
        "company" : "泉州市范特西智能科技有限公司",
        "participantExt" : {
          "position" : "董事长",
          "profile" : `陈慧聪长期从事智能制造行业，发明的多功能石材仿形机和石材表面抛光振动设备入选了泉州市数控一代示范企业，项目入选了福建省首台套重大专项，居国内领先地位。已经获得了国家专利142项，，美国发明专利1项，德国，意大利，爱尔兰等欧盟14个国家发明专利，日本发明专利1项，产业化业化效益十分可观。可以为我国智能制造产业发展升级作出突出贡献。
<span style='text-indent:2em;display:block'>获得多个红点产品设计奖，德国if产品设计奖，中国设计红星奖，等多个国内外设计奖项，多年从事机械制造相关工作，期间进行大量设计研究，带领团队开发多项智能化加工机械并应用同时将绿色设计融入日常生活。</span>
<span style='text-indent:2em;display:block'>在可持续发展的理念下利用回收塑料瓶制成环保编织鞋，只有130g。减少白色垃圾发明水溶性环保垃圾袋。项目可实现产值20亿。产品取得美国、欧洲和日本绿色环保认证。</span>`,
        }
      },
      {
        "id" : 56,
        "name" : "陈思聪",
        "avatar" : "/img/ddf-vote-photo/chensicong.jpg",
        "company" : "吉利控股集团设计",
        "participantExt" : {
          "position" : "高级经理、设计艺术学硕士",
          "profile" : "吉利控股集团设计高级经理，设计艺术学硕士，光华龙腾奖·浙江省设计业十大杰出青年前三甲。历任网易游戏体验设计师（负责《倩女幽魂》等大型网游的品牌设计）、阿里巴巴资深创意设计师（负责手机淘宝APP、手机天猫APP的创新设计）、中国移动高级设计专家（负责和家亲APP的体验与创新设计）。共获得德国iF概念奖、德国红点设计奖、德国iF设计奖、中国设计智造大奖银奖、中国设计智造大奖佳作奖、中国设计红星奖、中国青年互联网创业大赛铜奖等数十项国内外专业奖项。他秉承“美好设计、美好生活”的理念持续进行创新，所设计产品累计创造产值数千亿元人民币，用户覆盖了中国大部分人口。他是中国第二大游戏公司、中国最大电子商务平台、中国最大运营商和中国最大国产车公司设计创新的成功实践者。",
        }
      },
      {
        "id" : 236,
        "name" : "崔亮生",
        "avatar" : "/img/ddf-vote-photo/cuiliangsheng.jpg",
        "company" : "辽宁省机械工程学会工业设计分会",
        "participantExt" : {
          "position" : "常务理事",
          "profile" : "进入三洋SANYO开启16年设计历程，获得德国IF、红点、中国红星银奖等国内外三十余个奖项。服务一汽集团、华晨宝马、新松机器人、中科院沈阳自动化所、东软集团、长春光机所等五十家企业。2019年吴晓波提出“制造业升级拐点”，我们借势整合技术工程师、软件工程师、工业制造技术，融合设计资源产业链，构建智能工厂全案设计服务体系。“蚁群”智能生产系统稳定运行；铝合金大型框梁类柔性加工系统填补国内空白；国家04专项中打造沈阳航空制造首个智能工厂案例。2020年与优铸合作的自主智能工厂完成首轮融资和奠基，项目旨在建设智能示范工厂，缔造智造第一品牌。希望光华龙腾奖的平台持续推动东北设计产业发展！",
        }
      },
      {
        "id" : 167,
        "name" : "杜恒",
        "avatar" : "/img/ddf-vote-photo/duheng.jpg",
        "company" : "郑树芬室内设计（深圳）有限公司",
        "participantExt" : {
          "position" : "创始人、执行董事、设计总监",
          "profile" : "创立“雅奢主张”，主张“奢侈雅为度”的设计理念，致力倡导以中国文化元素及原创艺术品以国际化的视野合理运用于空间，带动中国青年设计师坚持做中国人自己的原创设计，用中国文化与当代艺术原创互相赋能，推动设计行业的进步发展，引领设计团队积极探索新型工艺技术让项目高效且环保落地，多年躬身笃行在设计教育、引领设计行业趋势、投资创新中国原创艺术行业经营模式以及创立SAP艺术国际权威奖项，帮助中国当代青年艺术家走向世界舞台，持续资助建设落后地区儿童的教学设施和审美素养教育，多方为设计行业推行民族文化自信与复兴做出杰出贡献。",
        }
      },
      {
        "id" : 76,
        "name" : "郝佳",
        "avatar" : "/img/ddf-vote-photo/haojia.jpg",
        "company" : "浙江中创时装有限公司",
        "participantExt" : {
          "position" : "深耕服装IP美学环保科技赋能创意人",
          "profile" : `北京中国纺联合会设计中心顾问/美国洛杉矶时装周副主席/浙江理工大学众创空间导师。个人专场发布多次亮相国内外各大官方时装周，在行业内外跨界发声。多年任职国内外品牌研发部总监及顾问，长期致力于品牌0-1孵化及生态平台的建设。积极践行绿色、时尚、科技行业定位；提出生态服装朴素制造的理念，为企业研发新的骆驼绒大衣、羊绒羽绒服等系列创新产品，尤其是100%动物绒不染色系列生态产品及可降解玉米纤维仿生皮草系列，该系列的多款服装单场直播超过百万的销售额；其空气代替羽绒、可穿戴的中药理疗系列填补了市场空白，是中国新零售时尚产业品牌升级与战略转型的创新推动者，全面助力纺织强国的建设。`,
        }
      },
      {
        "id" : 180,
        "name" : "呼伦夫",
        "avatar" : "/img/ddf-vote-photo/hu-lunfu.jpg",
        "company" : "天脉聚源（北京）传媒科技有限公司",
        "participantExt" : {
          "position" : "产品市场副总裁",
          "profile" : "作为新媒体交互设计领域的先锋人物，是设计、技术和创意复合型设计人，专注于新媒体，人机交互，视觉包装，数字营销，大数据可视化等领域的设计。多年来努力探索和研究互联网与电视媒体的边缘科技，第一发明人身份发明专利超过300项，负责过奥运会、亚运会、世界杯、春晚等上百个电视节目和全媒体演播室互动设计，并在疫情期间担任多个国家重点项目的产品设计师。曾获得国际广播电视行业奥斯卡Promax&BDA亚洲金奖和全球杰出银奖，是中国第一次获此殊荣，引领了行业技术创新。同时，积极推动行业和学术研究的协作发展，在央视、湖南卫视、华为DigixTalk、百度ABC峰会、清华美院、传媒大学等担任分享嘉宾。作为创意设计人曾获得光华龙腾中国设计业百人榜和ADMEN中国当代杰出广告人称号。",
        }
      },
      {
        "id" : 173,
        "name" : "胡传建",
        "avatar" : "/img/ddf-vote-photo/huchuanjian.jpg",
        "company" : "广州市亚洲吃面文化发展有限公司",
        "participantExt" : {
          "position" : "董事长",
          "profile" : "胡传建既是设计师，更是设计产业推动者。<span style='text-indent:2em;display:block'>通过洞察消费升级的时代变革，发现品牌年轻化及年轻人的品牌趋势，联合文创产业优势资源，致力于连接年轻人的创意和生意。为太二酸菜鱼、TIT创意园、元气寿司等设定品牌定位及品牌设计。</span><span style='text-indent:2em;display:block'>于2006年，与城市画报、创意中国网共同发起IMART创意市集，为各类新兴设计师和艺术家提供开放、多元的创作生态和交易平台，也是国内首个针对年轻人的大型创意交流先锋平台。目前分别在北京、上海、广州、苏州、厦门、杭州、重庆、西安、武汉、深圳等城市组织了过百场场创意市集。</span><span style='text-indent:2em;display:block'>2006年任广州国际设计周设计总监。参与策划了CDA中国设计奖、金堂奖、红棉奖、中国设计星等奖项活动。</span><span style='text-indent:2em;display:block'>个人曾荣获《快公司》颁发2015年“中国商业最具创意人物100强”奖项；带领的亚洲吃面公司，荣获《快公司》颁发的2015年、2016年“中国最佳创新公司”奖项。</span>",
        }
      },
      {
        "id" : 284,
        "name" : "胡依林",
        "avatar" : "/img/ddf-vote-photo/huyilin.jpg",
        "company" : "小牛电动创始人",
        "participantExt" : {
          "position" : "董事、研发副总裁",
          "profile" : `2013年怀着对美好出行愿景创立小牛，开创智能锂电电动车新品类。小牛电动已成为全球领先的智能城市出行解决方案提供商，NASDAQ上市企业。已推出N、M、U、G四个系列多款电动车，其中在过去20年中，M1、U1是仅有的两款获得全球7项最主要设计奖项大满贯的出行产品，将感性的设计思维与理性的AI大数据理论融合，不断的为全球市场推出模块化出行产品.创新的外形设计加入智能中枢ECU、传感器及NIUCLOUD，创造了智能电动骑行体验。
<span style='text-indent:2em;display:block'>曾服务于微软、FrogDesign，近20年横跨体验设计，工业设计，智能制造业的经历，开启了国际化视野。</span>
<span style='text-indent:2em;display:block'>仰望星空、脚踏实地，小牛用最好的设计和优质出行产品为中国智造的理念而努力。</span>`,
        }
      },
      {
        "id" : 266,
        "name" : "黄全",
        "avatar" : "/img/ddf-vote-photo/huzangquan.jpg",
        "company" : "WJID维几设计",
        "participantExt" : {
          "position" : "创始人、设计总监",
          "profile" : `2009年创立集艾设计，带领300余位设计师于2018年以年产值4.4亿被权威杂志《美国室内设计》评为中国区综合排名第1，全球榜排名第17，并连续多年纳税超3000万。   
<span style='text-indent:2em;display:block'>2019创立维几设计，在城市更新、历史保护建筑设计项目中积累了广泛的经验并产生了积极的社会效应，其中主持设计的上海幸福里、黑石公寓等项目被评为上海文创示范单位，让设计的价值最大的社会化，为上海的城市更新探寻了一条全新道路。</span>
<span style='text-indent:2em;display:block'>2020年为意大利家具品牌TURRI设计了全新的产品系列，让中国设计得到了更多的国际认可。</span>`,
        }
      },
      {
        "id" : 209,
        "name" : "简振哲",
        "avatar" : "/img/ddf-vote-photo/jianzhenzhe.jpg",
        "company" : "东软医疗系统股份有限公司",
        "participantExt" : {
          "position" : "设计总监",
          "profile" : `香港设计师，从业13年，2012年开始一直在国内工作，致力于推动中国医疗及设计的全球化。
<span style='text-indent:2em;display:block'>专注医疗领域软、硬件产品设计，已涉及30+医疗器械种类,包括医学影像、体外诊断、监护、呼吸、麻醉、药物管理、康复、外科等，亦曾为GE医疗、迈瑞医疗、蝶和科技、美国RxAdvance等公司设计产品。</span>
<span style='text-indent:2em;display:block'>其中东软医疗的CT和X光产品系列，迈瑞医疗的呼吸机、监护仪和输注泵，从诊断到治疗，在2020年全球抗击新冠肺炎中发挥关键作用。</span>
<span style='text-indent:2em;display:block'>成为中国区唯一入选世界设计组织WDO年轻设计师社团YDC，促进全球以及本地的设计事务；并秉承WDO的理念，倡导通过设计的使用来协助达到联合国可持续发展目标相一致。</span>
<span style='text-indent:2em;display:block'>获得30+国际国内设计奖项，主要包括IF、红点、IDEA。</span>`,
        }
      },
      {
        "id" : 110,
        "name" : "李博",
        "avatar" : "/img/ddf-vote-photo/libo.jpg",
        "company" : "深圳罗马仕科技有限公司",
        "participantExt" : {
          "position" : "总经理",
          "profile" : `设计转型的践行者，用设计思维进行协同创新，实现研究成果的市场转化，设计孵化全球首款消费级病原微生物快速检测仪，它在人类日常生活(衣、食、住、行)中对卫生状况进行实时分析、预警，经过数据分析，通过 APP客户端向用户同步卫生预警及指导方案。这些数据将接驳国家卫生疾控主管部门，为国家从时间、空间、季节等多个维度分 析当前及历史卫生数据分布基础状况，构建全国卫生状况预警系统，为人类健康提供全面基础数据保障。
<span style='text-indent:2em;display:block'>利用植物基因融合技术结合产品设计创新能力，打造传统农业产品设计孵化平台。打造跨界创新的产业链模式。</span>
<span style='text-indent:2em;display:block'>打造了全球销量第一的移动电源，罗马仕sense系列移动电源累计销售超过6000万台。</span>`,
        }
      },
      {
        "id" : 201,
        "name" : "李毅超",
        "avatar" : "/img/ddf-vote-photo/liyichao.jpg",
        "company" : "洛可可创新设计集团",
        "participantExt" : {
          "position" : "总裁",
          "profile" : `毕业于江南大学，从业13年以来，以“产品的系统性创新”为的思考与实践方向。
<span style='text-indent:2em;display:block'>2009年加入洛可可以来，历任设计师、深圳公司总经理、集团副总裁、总裁等职务，通过产品设计创造商业价值，并持续迭代设计行业的服务模式：</span>
<span style='text-indent:2em;display:block'>率先构建「设计+研发+供应链」的产品创新体系，让中小型企业补足产品研发、流程管理等多环节能力空白；</span>
<span style='text-indent:2em;display:block'>探索“垂直行业创新”的服务模式，如光电LED拼接屏行业，主持设计的拼接屏“黑玛瑙”囊括G-MARK、红点、iF奖金、IDEA等多镉大奖，并开启了该行业的高速发展。带领团队持续为该行业贡献专利68项、国际大奖50余项，行业产值从10亿上升为300亿，助推4家公司上市。</span>
<span style='text-indent:2em;display:block'>主持“数字化”的战略落地，积极探索数字设计产品与模式，以普惠全社会。</span>`,
        }
      },
      {
        "id" : 282,
        "name" : "刘建辉",
        "avatar" : "/img/ddf-vote-photo/lizujianhui.jpg",
        "company" : "Matrix Design矩阵纵横",
        "participantExt" : {
          "position" : "创始人、总设计师",
          "profile" : "从2012年起已八度入选英国Andrew Martin 室内设计大奖，设计作品也在德国RED DOT ,德国iF、美国IIDA、美国IDEA、香港APIDA、透视杂志大奖A&D Trophy Awards等顶级国际大奖频頻获奖，2020年被美国《interiordesign》杂志中文版评为封面人物。<span style='text-indent:2em;display:block'>公司创立十一年来一直坚持创新设计理念及创新管理理念齐头并进，并以“让设计回归东方，让中国设计走向国际”为目标，践行循环设计到循环经济企业宗旨。</span>",
        }
      },
      {
        "id" : 220,
        "name" : "牛旭",
        "avatar" : "/img/ddf-vote-photo/niuxu.jpg",
        "company" : "曙光信息产业股份有限公司",
        "participantExt" : {
          "position" : "国家级工业设计中心主任",
          "profile" : `十六年工业设计及管理经验，秉承中科曙光“自主创新服务中国”企业理念，围绕人工智能、云计算、大数据等领域，进行高性能计算机、通用服务器等产品的工业设计、产品化等工作，实现国际化品质的产品开发和品牌推广。  
<span style='text-indent:2em;display:block'>作为国家重大专项支持项目工业设计总负责人，完成了“曙光星云计算机系统”、“曙光5000A高性能计算机”、能效比全球领先的“硅立方液体相变冷却计算机”及国产化PC等重大科研项目的创新工作</span>。
<span style='text-indent:2em;display:block'>将用户体验、绿色设计思维与智能制造相融合，基于高性能计算领域行业特点进行融合创新，致力于提升中国高性能计算品牌的全球竞争力。从业以来获得专利120项，产品多年来创造了过百亿的销售额，9年蝉联中国高性能计算机TOP100排行榜市场份额第一。</span>`,
        }
      },
      {
        "id" : 283,
        "name" : "史玉洁",
        "avatar" : "/img/ddf-vote-photo/shiyujie.jpg",
        "company" : "百度",
        "participantExt" : {
          "position" : "百度设计高级总监",
          "profile" : `百度设计体验专业委员会主席。负责百度移动生态及商业全线产品和品牌的设计战略与发展整体管理，产品涵盖百度搜索、百度APP、百度贴吧、百度网盘，百度商业等，团队规模逾460人。
<span style='text-indent:2em;display:block'>带领百度移动生态用户体验团队，积累了丰富的“设计创新与产品体验”融合的实战经验。设计的疫情信息服务平台，帮助用户获得及时动态信息，免费医疗资讯和专业教育资源。国家政务平台助力政府数字化建设，让人们平等的享受到科技的简单和美好。</span>
<span style='text-indent:2em;display:block'>推动校企合作课程。主持撰写《方寸有度》，收录数篇国际期刊会议论文与百余项创新专利。所带团队多次被评为行业优秀设计组织。</span>`,
        }
      },
      {
        "id" : 185,
        "name" : "汪睿",
        "avatar" : "/img/ddf-vote-photo/wang-rui.jpg",
        "company" : "阳光电源股份有限公司",
        "participantExt" : {
          "position" : "工业设计总监",
          "profile" : `积极投入到清洁可再生能源的事业中，扎根清洁能源领域11年，将绿色设计理念融入产品全生命周期。同时，以设计思维孵化公司战略新业务-智能清扫机器人业务和充电桩业务，提升清洁能源的利用率。
<span style='text-indent:2em;display:block'>善于将设计目标放入系统中进行思考，策略性的解决产品、系统、体验中的问题。带领团队建立了一套国际化的设计语言，引领了清洁电力转换设备的设计趋势。</span>
<span style='text-indent:2em;display:block'>2013年在国内率先开展光伏扶贫，推出高效发电的光伏逆变器，1台设备每年可以产生3000元的收益。建立了村、户、电站的立体化精准扶贫模式，惠及30万贫困户、2200个贫困村。</span>
<span style='text-indent:2em;display:block'>逆变器系列化产品在国内外的市场都取得佳绩，顺利打入欧美日等高端市场，年销售收入达到10亿以上。</span>
<span style='text-indent:2em;display:block'>2019年中心获批国家级工业设计中心。</span>`,
        }
      },
      {
        "id" : 238,
        "name" : "王红胜",
        "avatar" : "/img/ddf-vote-photo/wanghongsheng.jpg",
        "company" : "重庆邮电大学",
        "participantExt" : {
          "position" : "产品设计教研室主任",
          "profile" : `扎根西部乡村设计扶贫事业近十年，行迹遍布100多个乡村，为奉节、巫山等多个地方政府提供产业扶贫和乡村振兴发展全链服务。
<span style='text-indent:2em;display:block'>构建“品牌顶层设计—产业数字化—数字乡村”一站式服务设计体系。至今已打造数十个精准扶贫品牌服务设计标杆案例。其中，奉节脐橙品牌价值增至182.8亿元，被评为2019年中国农业品牌建设学府奖十佳品牌案例奖，是“一棵树从养活30万人到致富30万人”的重要推动者；巫山脆李品牌价值增至19.08亿元，并被评为“中国果业扶贫优秀品牌”；开县春橙品牌价值增至13.74亿元，被评为2019年中国农业品牌建设学府奖优秀品牌案例奖等荣誉。</span>`,
        }
      },
      {
        "id" : 51,
        "name" : "王强",
        "avatar" : "/img/ddf-vote-photo/wangqiang.jpg",
        "company" : "杭州若奇技术有限公司",
        "participantExt" : {
          "position" : "火鸡电器CEO",
          "profile" : "老板电器CTO、创新研究院院长和设计总监，擅长消费者探究与洞察，有十余年打造家电行业爆品的经验。多次获得德国IF设计奖、德国红点设计奖、中国设计智造大奖智造奖、中国设计红星奖、工业设计精英人物、浙江省工业设计十佳、光华龙腾･浙江设计业十大杰出青年、新锐设计师等多内外专业奖项。在消费升级的大背景下，火鸡电器专注于打造让厨房更健康的创意厨电，传递健康烹饪的生活方式。在产品方面，从智能消毒刀架切入，开创了一个新品类，未来将更聚焦消杀领域，围绕新的用户需求切入广阔的家庭厨电市场。",
        }
      },
      {
        "id" : 281,
        "name" : "辛军",
        "avatar" : "/img/ddf-vote-photo/xinjun.jpg",
        "company" : "深圳辛视装饰设计有限公司",
        "participantExt" : {
          "position" : "创始人",
          "profile" : "毕业于意大利米兰理工设计学院，2009年创立深圳辛视装饰设计有限公司。专注于空间环境整体设计，主张做恰到好处的设计，有情感的空间，以少胜多，致力于用好的设计创造价值，创造美好生活。<span style='text-indent:2em;display:block'>以躬行实践探索设计的本质，在文学、艺术当中寻求设计的精神，在东方与西方、当代与历史中寻找设计的思想，力求为每个空间营造其该有的空间氛围，创造出独有的空间气质，使人为之动容，主要设计领域包括酒店、餐饮、商业办公、住宅、等。</span>",
        }
      },
      {
        "id" : 267,
        "name" : "徐洪军",
        "avatar" : "/img/ddf-vote-photo/xuhongjun.jpg",
        "company" : "杭州源骏实业集团有限公司",
        "participantExt" : {
          "position" : "创始人&董事长",
          "profile" : `2007年创立源骏，首创提出“工业设计系统的集成商”和“打造企业最坚实创新外脑”理念，致力于打造工业设计生态链平台，助力产业发展，为中国产业转型升级服务。在厨房家电、机电工具设计等领域与300多家品牌建立了长期系统的战略合作关系，打造了1000个以上的创新产品、创造了1000个以上核心专利，为合作伙伴带来1000亿以上的商业价值。
<span style='text-indent:2em;display:block'>13年来努力追逐设计趋势，发现和满足未来的用户需求，成就产品核心价值的升级和创新，具有领先的战略指导思路。</span>`,
        }
      },
      {
        "id" : 216,
        "name" : "徐清明",
        "avatar" : "/img/ddf-vote-photo/xuqingming.jpg",
        "company" : "重庆浪尖渝力科技有限公司",
        "participantExt" : {
          "position" : "总经理",
          "profile" : `致力于西部地区工业设计与区域经济融合发展的研究者与实践者，带领团队服务于701所、709所、华为、中兴等上百家国内一流企业，涉及领域包含国产航母、核潜艇等，获得国家级工业设计中心等20多项荣耀，
<span style='text-indent:2em;display:block'>带领团队参与设计抗疫、设计扶贫、乡村振兴等公益事业；</span>
<span style='text-indent:2em;display:block'>聚合国内外优质设计资源，规建建设D+M浪尖智造工场、江津工业设计研究院、重庆市智能制造产业公共服务平台等多个平台， 引入欧洲一流设计企业落户重庆，落实国家“一带一路”战略。</span>
<span style='text-indent:2em;display:block'>规划建设重庆工业设计产业生态体系“重庆工业设计产业城”，聚合多所高校，规划建设“西部（重庆）工业设计联合创新学院”，以设计为手段、深入落实 “成渝地区双城经济圈建设”和“西部科学城建设” 国家战略。</span>`,
        }
      },
      {
        "id" : 113,
        "name" : "许二建",
        "avatar" : "/img/ddf-vote-photo/xuzerjian.jpg",
        "company" : "深圳市TTF高级珠宝",
        "participantExt" : {
          "position" : "设计总监",
          "profile" : "毕业于南京艺术学院珠宝设计专业， 深圳市TTF高级珠宝 设计总监 副总裁，中国传统翡翠当代设计国际化推动者，中国传统生肖文化当代设计国际化推动者，奥林匹克博览会青少年美术大展冠军奖杯、历年冬奥会纪念邮票包装全案设计师，2019年深圳市设计业十大杰出青年，连续10届TTF生肖首饰设计大展 评委 联合策展人，深圳市珠宝首饰设计师协会创办人 副会长，南京艺术学院TTF许二建奖学金创建人，深圳设计40年珠宝行业专访代表人物，深圳礼物设计大赛 评委，绿色设计援藏计划-甘南藏族自治州藏文化创新创意产业项目发起人、创作人。",
        }
      },
      {
        "id" : 194,
        "name" : "杨凯",
        "avatar" : "/img/ddf-vote-photo/yangkai.jpg",
        "company" : "山东凯雷德工业设计有限公司",
        "participantExt" : {
          "position" : "设计总监",
          "profile" : `在机械装备领域深耕8年，致力于农业设备、工程机械、专用车辆等产品的工业设计创新。组织创立国内第一家融合设计创新和技术创新，具备机械装备整机设计制造能力的工业设计公司，提出“机械装备工业设计协同创新”新模式。帮助多家企业成为单品类销量冠军，累计增收超过5亿元。
<span style='text-indent:2em;display:block'>主导完成国内唯一8K数字电影摄影机设计工作，打破全球电影机领域被国外品牌垄断的局面，弥补我国超高清视频产业前端制作技术和内容生产短板，为超高清视频摄录提供强有力的设备和技术保障。</span>
<span style='text-indent:2em;display:block'>主持国内首台多功能绿化综合养护车设计制造，集修剪、粉碎、回收于一体的道路绿化养护，代替大量人工，提高作业安全性，节约成本。</span>`,
        }
      },
      {
        "id" : 189,
        "name" : "杨哲",
        "avatar" : "/img/ddf-vote-photo/yangzhe.jpg",
        "company" : "新石器慧通（北京）科技有限公司",
        "participantExt" : {
          "position" : "创始人、总设计师",
          "profile" : `十多年来一直投身物流智能产品领域。设计开发新石器无人车，已在6个国家，30多个城市，100多个场景中投入运营。疫情发生后在多地投放几十辆无人车投入抗疫工作中。
<span style='text-indent:2em;display:block'>设计开发第一款国人物流智能终端；设计开发国内首款智能快递柜；设计开发国内首款便携式电子运单打印机；主导设计研发全球首例无人机送快递项目。</span>
<span style='text-indent:2em;display:block'>疫情期间参与防疫控疫的物资保障、无人配送等公益服务工作中。应用新石器无人车，在武汉、北京、上海、广州、深圳、西安、嘉善、苏州、成都等地使得无人配送服务及无人化防疫工作的公益活动落地运营。获得各地政府和服务方的嘉赏和感谢。</span>
<span style='text-indent:2em;display:block'>研发快递员手持PDA，在顺丰、德邦等快速公司普及，推动中国物流数字化时代进程；设计开发国内首款便携式电子运单打印机，实现信息电子化无纸化操作。发明快递柜，优化收派件流程，解决千万快递员最后一公里效率难题。</span>`,
        }
      },
      {
        "id" : 280,
        "name" : "张玮",
        "avatar" : "/img/ddf-vote-photo/zhangwei.jpg",
        "company" : "厦门一横一竖设计工程有限公司",
        "participantExt" : {
          "position" : "创始人兼设计总监",
          "profile" : "厦门新锐空间设计师，设计形态简洁大方且丰富多元，擅长将空间结构特点与功能使用特性完美结合，用最少的动作做出最佳效果，让空间实现最大价值。“做最适合的设计”让他备受业主及业内人士的一致好评。<span style='text-indent:2em;display:block'>从业以来获得多项设计大奖： 2018年获得创新中国-十大原创设计人物； 2019获得中国装饰设计业十大杰出青年；2019-2020获得40UNDER40中国设计杰出青年；2019年获得法国INNODESIGN PRIZE国际创新与设计大奖，2020年入选ANDREW MARTIN国际室内设计年鉴、陈设中国.晶麒麟奖-陈设艺术品奖大奖。</span>",
        }
      },
      {
        "id" : 162,
        "name" : "张运彬",
        "avatar" : "/img/ddf-vote-photo/zhangyunbin.jpg",
        "company" : "广东省善易交互设计研究院（IXDC）",
        "participantExt" : {
          "position" : "联合创始人、秘书长",
          "profile" : "中国用户体验设计领域杰出行业推动者，引领中国体验设计行业发展。<span style='text-indent:2em;display:block'>第九、十届“省长杯”工业设计大赛-交互专项赛负责人；连续8年的《中国用户体验行业调查报告》负责人；连续10年的《国际体验设计大会》主策划、项目负责人。2008年荣获北京奥运会“奥运报道先进个人”；2010年荣获第16届广州亚运会杰出贡献荣誉；2018年荣获第九届“省长杯”工业设计大赛先进个人。</span><span style='text-indent:2em;display:block'>在超过15年的工作时间内坚持不懈地传播体验创新价值理念，推动体验设计、交互设计、服务设计行业变革，为中国企业用户体验团队建设、为“设计广东”走向国际化做出行业贡献。</span>",
        }
      },
      {
        "id" : 285,
        "name" : "赵天翔",
        "avatar" : "/img/ddf-vote-photo/zhaotianxiang.jpg",
        "company" : "滴滴出行",
        "participantExt" : {
          "position" : "高级设计总监",
          "profile" : `从2005年进入设计相关行业，先后服务于搜狐、百度、360、滴滴等互联网公司，主导众多核心项目，迄今已深耕互联网行业15载。
<span style='text-indent:2em;display:block'>期间，从零到一成立了滴滴CDX创意设计部，秉承着"向前一步"的价值观推动设计职能在滴滴公司内部的发展，带领不同类型的设计类专业成员不断成长，不断探索及推动设计价值的最大化。在体验设计／服务设计/产品设计/工业设计/营销设计/运营设计/创意策略／创意执行／品牌管理／品牌设计/滴滴衍生设计等专业层面建立了自己的理解及理论，并影响团队及赋能设计行业。</span>
<span style='text-indent:2em;display:block'>带领团队在iF Product Design Award、红星奖、IAI国际广告奖、DIA中国设计智造大奖、GXA好体验奖等荣获多项大奖，个人获得新中国成立70周年用户体验设计70人称号。</span>`,
        }
      },
      {
        "id" : 223,
        "name" : "周林",
        "avatar" : "/img/ddf-vote-photo/zhoulin.jpg",
        "company" : "北京上品极致产品设计有限公司",
        "participantExt" : {
          "position" : "创始人、董事长",
          "profile" : `作为上品设计创始人，以“工业设计”作为第一驱动力，于2009年创办上品设计，旗下拥有十二大机构。服务包含央企国企、总参、跨国集团、知名公司近千家。一直坚持“让中国工业设计受世人尊重”为设计目标。
<span style='text-indent:2em;display:block'>2018年成立“TOP TEN”产业链，旨在提升全产业链的整体协助能力，利用上品设计自身的优势推动设计产业的发展。帮助企业实现从创新策略，到创新概念，再到落地上市全链条整体包装，目前上品设计已经成功助力2000余家企业将3000多个产品推向市场，带动多个产业的设计发展。</span>
<span style='text-indent:2em;display:block'>2019年【国庆70周年】创新驱动彩车主创设计师。让上品设计成为“唯一”一个设计企业，开创三个彩车合一的先河。人民日报给予“最意外的”彩车。受到群众游行总指挥部高度评价，特颁发感谢信以表奖励。</span>`,
        }
      },
      {
        "id" : 251,
        "name" : "祝正文",
        "avatar" : "/img/ddf-vote-photo/zhuzhengwen.jpg",
        "company" : "中国信息通信科技集团烽火通信科技股份有限公司",
        "participantExt" : {
          "position" : "MIFON品牌CEO、用户体验中心总经理",
          "profile" : `研究信息通信及智能硬件行业、从业15年的一线工业设计师、全链路用户体验设计师，职业生涯参与多个项目实战，服务品牌：MIFON、IBM、HP、DELL、BELKIN、AEG、EATON、中国电信、移动、联通等。两次担任“国家863项目”工业设计创新负责人角色，获得多项发明及实用新型专利。
<span style='text-indent:2em;display:block'>针对业务经营特性将工设、结构、包装、用研、交互、界面、品牌及软件开发等领域整合为用户体验中心。通过建立设计体系流程，将用户体验设计规划与公司技术规划、产品规划融合，提升了公司产品开发效率与质量。引进全链路设计师培养模式，培养创新人才百余人。六年时间支撑产出线业务规模从不到四千万迈入年产规模超百亿。</span>
<span style='text-indent:2em;display:block'>2019年至今同时担任公司子品牌MIFON CEO，聚焦细分领域打造公司新的业务增长点。</span>`,
        }
      }
    ]

    this.getVoteCount()
  },
  computed: {
    getPrizeText() {
      for (let i = 0, l = this.prizeList.length; i < l; i++) {
        if (this.prizeId == this.prizeList[i].id) {
          return this.prizeList[i].shortName;
        }
      }
      return "-";
    }
  },
  methods: {
    // 投票是否截止
    // isEnd() {
    //   let endDate = "2020-12-16";
    //   let dt = new Date();
    //   let sYear = dt.getFullYear() + "";
    //   let sMonth =
    //     dt.getMonth() + 1 < 10
    //       ? "0" + (dt.getMonth() + 1)
    //       : dt.getMonth() + 1 + "";
    //   let sDate = dt.getDate() < 10 ? "0" + dt.getDate() : dt.getDate() + "";
    //   let dNow = sYear + "-" + sMonth + "-" + sDate;
    //   // dNow = dt.getFullYear() + '-' + (dt.getMonth() + 1) + '-' + dt.getDate()
    //   // console.log(dNow)
    //   if (dNow > endDate) {
    //     this.endVote = true;
    //     return true;
    //   }
    //   return false;
    // },
    // 投票是否截止
    isEnd() {
      let endDate = new Date(2020, 11, 12, 9, 0, 0, 0);
      let dNow = new Date();
      // console.log(endDate)
      // console.log(dNow)
      if (dNow > endDate) {
        this.endVote = true;
        return true;
      }
      return false;
    },
    // 投票是否开始
    isStart() {
      let startDate = new Date(2020, 11, 9, 9, 0, 0, 0);
      let dNow = new Date();
      if (dNow > startDate) {
        this.startVote = true;
        return true;
      }
      return false;
    },
    // 退出登录
    logOut() {
      this.$store.commit("setToken", "");
      this.$store.commit("setUserInfo", {});
      window.localStorage.removeItem("login_time");
      this.$router.go(0);
    },
    // 获取当前用户参与投票信息
    getUserDdfVote() {
      let userId = this.$store.getters.userInfo.id;
      Service.getUserDdfVote({ "userId.eq": userId, "prizeId.eq": 6 })
        .then(res => {
          if (res.errorNo == 0) {
            if(res.data && res.data.length > 0){
              this.userVote = true
              // for(let i=0;i<res.data.length;i++){
              //   this.selectList.push(res.data[i].voteId)
              // }
            }
          } else {
            this.$Message.error(res.errorMessage);
          }
        })
        .catch(() => {
          this.$Message.error("连接服务器失败，请稍后再试");
        });
    },
    // 投票
    vote() {
      if (this.gIsLogin()) {
        if (this.userVote) {
          this.$Message.info("您已经参与过投票，不能重复参与。");
          return;
        }
        if (this.selectList.length == 0) {
          this.$Message.info("请选择投票人员！");
          return;
        }
        if (this.selectList.length != 10) {
          this.$Message.info("请选择10人投票。");
          return;
        }
        let condition = {};
        condition.prizeId = this.prizeId;
        condition.voteIds = this.selectList;
        this.submitting = true;
        Service.voteDdf(condition)
          .then(res => {
            this.submitting = false;
            if (res.errorNo == 0) {
              this.$Message.success("投票成功！");
              this.selectList = [];
              this.userVote = true;
              this.getVoteCount()
            } else {
              this.$Message.error(res.errorMessage);
            }
          })
          .catch(() => {
            this.submitting = false;
            this.$Message.error("连接服务器失败，请稍后再试");
          });
      } else {
        this.$Modal.info({
          title: "提示",
          content: "登录后才能参与投票",
          okText: "去登录",
          onOk: () => {
            this.$router.push(
              `/login?fromUrl=/ddf_vote_newer?p_type=${this.prizeId}`
            );
          }
        });
      }
    },
    // 选中某一项
    select(id) {
      let i = this.selectList.indexOf(id);
      if (i == -1) {
        if (this.selectList.length >= 10) {
          this.$Message.warning("每位用户最多可为10人投票");
          return;
        } else {
          this.selectList.push(id);
        }
      } else {
        this.selectList.splice(i, 1);
      }
    },
    // 获取得票数
    getVoteCount(){
      for(let i=0;i<this.list.length;i++){
        Service.getUserDdfVote({ "voteId.eq": this.list[i].id, "prizeId.eq": 6, "size":1 })
          .then(res => {
            if (res.errorNo == 0) {
              this.list[i].voteCount = res.totalSize
              this.$forceUpdate()
            } else {
              // this.$Message.error(res.errorMessage);
            }
          })
          .catch(() => {
            // this.$Message.error("连接服务器失败，请稍后再试");
          });
      }
    },
    // 获取参评类型
    getPrizeList() {
      this.loading = true;
      Service.getDDFPrize()
        .then(res => {
          if (res.errorNo == 0) {
            this.prizeList = res.data;
            // this.prizeId = this.prizeList[0].id;
            this.getList();
          } else {
            this.$Message.error(res.errorMessage);
          }
        })
        .catch(() => {
          this.$Message.error("连接服务器失败，请稍后再试");
        });
    },
    // 获取人员列表
    getList() {
      let condition = {
        page: 0,
        size: 30,
        "status.eq": 2,
        "pType.eq": this.prizeId
      };
      this.loading = true;
      Service.getDDFRegistration(condition)
        .then(res => {
          if (res.errorNo == 0) {
            this.list = res.data;
            this.total = res.totalSize;
          } else {
            this.$Message.error(res.errorMessage);
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          this.$Message.error("连接服务器失败，请稍后再试");
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.workList {
  min-height: 100%;
  padding-top: 50px;
  .banner {
    position: relative;
    padding-bottom: 54.45%;
    .bannerImg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
    }
  }
  .header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 50px;
    // background: url(/img/navBg.jpg) no-repeat center #ffffff;
    background: rgba(0, 0, 0, 0.85);
    background-size: cover;
    text-align: right;
    z-index: 999;

    .logo {
      float: left;
      width: 70px;
      margin-top: 4px;
    }

    .nav {
      line-height: 50px;
      color: #fff;
      padding: 0 10px;
      margin-left: 10px;
      cursor: pointer;
    }
  }
  .note-info {
    padding: 20px 0 5px;
    line-height: 26px;
  }
  .type {
    padding: 5px 0;
    line-height: 26px;
  }
  .note {
    padding: 10px 0;
    text-align: center;

    .turn {
      animation: turn 1s linear infinite;
      margin-bottom: 10px;
    }
    @keyframes turn {
      0% {
        -webkit-transform: rotate(0deg);
      }
      25% {
        -webkit-transform: rotate(90deg);
      }
      50% {
        -webkit-transform: rotate(180deg);
      }
      75% {
        -webkit-transform: rotate(270deg);
      }
      100% {
        -webkit-transform: rotate(360deg);
      }
    }
  }
  .voteTitle {
    text-align: center;
    padding: 20px 15px;
    font-size: 20px;
    color: #d30830;
  }
  .voteTitle2 {
    display: inline;
  }
  @media (max-width: 768px) {
    .voteTitle2 {
      display: block;
    }
  }
  .workWrap {
    padding: 133.33% 0 0;
    margin-bottom: 20px;
    box-shadow: 0 1px 1px #ccc;
    position: relative;
    overflow: hidden;

    .img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
    }

    .info {
      position: absolute;
      top: 0;
      bottom: 0;
      padding: 92% 0 0;
      color: #525252;
      overflow: auto;
      -webkit-overflow-scrolling: touch;

      .textInfo {
        padding: 5px 10px;
        background: #fff;
      }

      .opacityDiv {
        padding-bottom: 105%;
      }

      .workName {
        font-size: 16px;
        font-weight: bold;
        color: #d30830;
      }
    }

    .profile{
      text-align: justify;
      text-indent: 2em;
    }

    .info::-webkit-scrollbar {
      display: none;
    }

    .voteCount {
      position: absolute;
      width: 50px;
      height: 26px;
      top: 0;
      left: 0;
      line-height: 26px;
      text-align: center;
      color: #ffffff;
      background: rgba($color: #000000, $alpha: 0.5);
      z-index: 9;
    }

    .selectBtn {
      position: absolute;
      width: 44px;
      height: 44px;
      border-radius: 50px;
      top: 5px;
      right: 5px;
      line-height: 44px;
      text-align: center;
      border: 1px solid #d30830;
      color: #d30830;
      background: rgba($color: #ffffff, $alpha: 0.5);
      cursor: pointer;
      z-index: 9;
    }
  }

  .btnWrap {
    padding: 30px 0;
    text-align: center;
  }
  .jishu {
    text-align: center;
    padding: 0 0 20px;
    font-size: 12px;
  }
  .footer {
    padding: 50px 0;
    line-height: 1.8em;
    background: #ac1a2c;
    color: #f2f2f2;

    .code {
      width: 50%;
      max-width: 110px;
      padding: 10px 0;
    }
  }
}
</style>
